import { DatePicker as _DatePicker, type DatePickerProps } from '@zillow/constellation';
import { dateMax, dateMin, parseDate } from '../../utils/formatters';

function minMaxDatePickerWorkaround(props: Pick<DatePickerProps, 'minDate' | 'maxDate' | 'selected'>) {
  // If current datePicker value is outside of min and max range, the DatePicker
  // fails to show any year and the month next and previous buttons are disabled,
  // this is a bug in the component itself, so this is a workaround.

  return {
    ...props,
    minDate: props.minDate && dateMin([parseDate(props.minDate), parseDate(props.selected)]),
    maxDate: props.maxDate && dateMax([parseDate(props.maxDate), parseDate(props.selected)]),
  };
}

/** A @zillow/constellation DatePicker dropin replacement with the minDate and maxDate workaround
 * for preventing bug of the the next/prev month buttons and the current year not showing up
 */
export function DatePickerFix(props: DatePickerProps) {
  return <_DatePicker {...props} {...minMaxDatePickerWorkaround(props)} />;
}
